import React from 'react';

import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import AlertManager from 'src/components/alert/AlertManager';
import { PopoverMenu, RadioField } from 'src/components/basic';
import config from 'src/config';

import { lang, logger } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

export default class Options extends React.PureComponent {
  warn = logger.warn.bind(logger, 'Message');

  onClickRemove = (close) => {
    const { onRemoveMessage, own, item, type } = this.props;
    let name = type !== 'treatment' ? 'message' : 'treatment';
    let removeExpired = item.date < Date.now() - config.get('editTreatmentsTime');
    if ((own && type !== 'treatment') || (type === 'treatment' && !removeExpired)) {
      AlertManager.popup(AlertManager.TYPES.WARN, {
        title: lang.t(LANG_CONST.notice.delete_selected, { name }),
        close: false,
        body: ({ dataForm, setDataForm }) => {
          if (type === 'treatment') return null;
          return (
            <div className={'mc-flex'}>
              <RadioField
                template={'2'}
                checked={!!dataForm.isRemoveAll}
                onClick={(e) => {
                  e.preventDefault();
                  setDataForm({ isRemoveAll: !dataForm.isRemoveAll });
                }}
                onChange={() => {}}
                label={LANG_CONST.text.delete_for_everyone}
              />
            </div>
          );
        },
        actionButton: {
          label: LANG_CONST.buttons.yes,
          action: ({ hide, dataForm }) => {
            onRemoveMessage(!!dataForm.isRemoveAll);
            hide();
          }
        },
        cancelButton: {
          label: LANG_CONST.buttons.no,
          action: (props) => {
            props.hide();
          }
        }
      });
    } else {
      onRemoveMessage(false);
    }
    close();
  };

  render() {
    const { onEditMessage, own, item, type } = this.props;
    let removeExpired = item.date < Date.now() - config.get('editTreatmentsTime');

    let editAvailable =
      own &&
      (['text', 'audio', 'image', 'video'].includes(type) ||
        (type === 'treatment' && !removeExpired));
    let removeAvailable =
      ['text', 'audio', 'image', 'video'].includes(type) ||
      (type === 'treatment' && !removeExpired);

    if (!editAvailable && !removeAvailable) return null;

    return (
      (!own || item.state !== 'sending') && (
        <PopoverMenu
          placement={own ? 'bottom-end' : 'bottom-start'}
          arrowOffset={own ? 68 : -90}
          layerClass={'mc-display-contents'}
          menu={(close) => (
            <div className={'mc-flex-col mc-bg-white'}>
              {editAvailable && (
                <div
                  className={'mc-no-style-btn mc-flex mc-p15'}
                  onClick={() => {
                    onEditMessage(item);
                    close();
                  }}
                >
                  <SVGIcon iconname={BASE_ICONS.EDIT} width={30} />
                  <div className={'mc-value-520'}>{lang.t(LANG_CONST.buttons.edit)}</div>
                </div>
              )}
              {removeAvailable && (
                <div
                  className={'mc-no-style-btn mc-flex mc-p15'}
                  onClick={() => this.onClickRemove(close)}
                >
                  <SVGIcon iconname={BASE_ICONS.DELETE} width={30} />
                  <div className={'mc-value-520'}>{lang.t(LANG_CONST.buttons.remove)}</div>
                </div>
              )}
            </div>
          )}
          className={'mc-options-msg'}
        >
          {(isOpen) => (
            <div className={'mc-options-msg-btn ' + (isOpen ? 'mc-opening' : '')}>
              <SVGIcon iconname={BASE_ICONS.DOTS} width={24} />
            </div>
          )}
        </PopoverMenu>
      )
    );
  }
}
